module.exports = __webpack_public_path__ + "static/ABONNEMENT_FULL-e258f1b5045172cd3f56699382b9161a.png";